module.exports = __webpack_public_path__ + "static/media/img-01.45ec65ad.jpg";